import React from 'react'
import styles from "./footer.module.scss"
function Footer() {
  return (
    <footer className={styles.footer}>
        <h4>© 2025 Mansi's Portfolio</h4>
    </footer>
  )
}

export default Footer